// Import the functions you need from the SDKs you need
// FIREBASE DISABLED - Uncomment below imports to re-enable
// import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// import { getPerformance, trace } from "firebase/performance";

// console.log("Firebase is currently DISABLED");

// console.log("check keys value", {
//   key: process.env.FIREBASE_API_KEY,
//   messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
//   appId: process.env.FIREBASE_APP_ID,
//   measurementId: process.env.FIREBASE_MEASUREMENT_ID,
//   my_env: process.env.MY_ENV,
//   sentryDSN: process.env.SENTRY_DSN,
// });

// //web app's Firebase configuration
// const firebaseConfig = {
//   development: {
//     //   apiKey: "AIzaSyD18EQ8Wq9cU6Oenk-iFh7cunOtq1myVb8",
//     apiKey: process.env.FIREBASE_API_KEY,
//     authDomain: "twinleaves-dev.firebaseapp.com",
//     projectId: "twinleaves-dev",
//     storageBucket: "twinleaves-dev.appspot.com",
//     messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
//     appId: process.env.FIREBASE_APP_ID,
//     measurementId: process.env.FIREBASE_MEASUREMENT_ID,
//   },
//   stage: {
//     apiKey: process.env.FIREBASE_API_KEY,
//     authDomain: "twinleaves-dev.firebaseapp.com",
//     projectId: "twinleaves-dev",
//     storageBucket: "twinleaves-dev.appspot.com",
//     messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
//     appId: process.env.FIREBASE_APP_ID,
//     measurementId: process.env.FIREBASE_MEASUREMENT_ID,
//   },
//   production: {
//     apiKey: process.env.FIREBASE_API_KEY,
//     authDomain: "twinleaves-dev.firebaseapp.com",
//     projectId: "twinleaves-dev",
//     storageBucket: "twinleaves-dev.appspot.com",
//     messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
//     appId: process.env.FIREBASE_APP_ID,
//     measurementId: process.env.FIREBASE_MEASUREMENT_ID,
//   },
// }[process.env.MY_ENV];

// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
// export const performance = getPerformance(app);

// FIREBASE DISABLED - Stub exports to prevent import errors
export const performance = null;

//starts a performance trace for an HTTP request
//allows you to measure the time taken for specific operations and gather performance metrics.
// FIREBASE DISABLED - Returns a stub object
export const startFirebaseTrace = (traceName) => {
  // Return a stub object that mimics the trace interface
  return {
    start: () => {},
    stop: () => {},
    putAttribute: () => {},
  };
};

// function sanitizeAttributeValue(value) {
//   return value.replace(/[^a-zA-Z0-9-_./:?=&]/g, ""); // Remove unwanted characters
// }

// FIREBASE DISABLED - No-op function
export const stopFirebaseTrace = async (
  httpTrace,
  response = null,
  request = null,
  startTime = null
) => {
  // Do nothing - Firebase is disabled
};

// FIREBASE DISABLED - Export null instead of analytics
const analytics = null;
export default analytics;
